module.exports = __webpack_public_path__ + "img/ISO13485-2016.ecc2204d.jpg";